import React from "react"
import styled from "styled-components"

const QuoteWidget = styled.section``

export default ({ fromPage, category }) => {
    let formAction = ""
    let inputName = "zipCode"
    const allId = null
    switch (category) {
        case "Individual and Family":
            formAction = `https://www.${process.env.GATSBY_SUBDOMAIN ||
                ""}ehealthinsurance.com/individual-family-health-insurance${
                allId ? `?allid=${allId}` : ""
            }`
            inputName = "zipCode"
            break
        case "Small Business":
            formAction = `https://www.${process.env.GATSBY_SUBDOMAIN ||
                ""}ehealthinsurance.com/small-business-health-insurance/group-health-insurance-plans${
                allId ? `?allid=${allId}` : ""
            }`
            break
        case "Medicare":
            formAction = `https://www.${process.env.GATSBY_SUBDOMAIN ||
                ""}ehealthmedicareplans.com/v2`
            inputName = "zip"
            break
        case "Coronavirus Updates and Resources":
            formAction = `https://www.${process.env.GATSBY_SUBDOMAIN ||
                ""}ehealthinsurance.com${allId ? `?allid=${allId}` : ""}`
            inputName = "zipCode"
            break
        default:
            break
    }
    return (
        <QuoteWidget
            id="amp-quote-widget"
            className="amp-quote-widget"
        >
            <div className="container amp-quote-widget__content">
                <div className="amp-quote-widget__title">
                    Comparison shopping with just your zip code.
                </div>
                <form
                    method="get"
                    action={formAction}
                    target="_top"
                    custom-validation-reporting="as-you-go">
                    <div className="amp-quote-widget__form">
                        <div className="form-group">
                            <label htmlFor="as-you-go-zipcode">Zip code</label>
                            <input id="as-you-go-zipcode" name={inputName} type="text" pattern="^[0-9]{5}(?:-[0-9]{4})?$" maxLength="5" required />
                            <div className="error-message" visible-when-invalid="patternMismatch" validation-for="as-you-go-zipcode">Typo? Zip code is not valid.</div>
                        </div>
                        <input
                            type="submit"
                            className="button-primary"
                            value="Find Plans"
                        />
                    </div>
                </form>
            </div>
        </QuoteWidget>
    )
}
